import {Box, Typography, useTheme, Button} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {FallbackProps} from 'react-error-boundary';

export default function GlobalError(props: FallbackProps) {
	const theme = useTheme();
	const {t} = useTranslation();
	return (
		<>
			<Box className="text-center">
				<Typography
					component={'div'}
					sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
					className="p-10 font-bold"
				>
					{t('something_happened')}
				</Typography>
				<Typography
					component={'div'}
					sx={{
						color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
					className="p-10 font-bold"
				>
					{/*{props.error.toString()}*/}
				</Typography>
				<Button
					size="small"
					color="primary"
					variant="outlined"
					onClick={() => props.resetErrorBoundary}>
					{t('try_again')}
				</Button>
			</Box>
		</>
	);
}
